import React, { useMemo, useState } from "react";
import { Alert, Button } from "reactstrap";
//redux`
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import CountUp from "react-countup";
import { Card, CardBody, Col } from "reactstrap";
import DraggableKPIs from "./DraggableKPIs";
import AlertaBadge from "./AlertaBadge";
import PercentilesBadge from "./PercentilesBadge";
import CoeficienteVariacionBadge from "./CoeficienteVariacionBadge";
import ModalAyudaMetrica from "./ModalAyudaMetrica";
import ModalOutliersProveedor from "./ModalOutliersProveedor";
import ModalOutliersDesviacionProveedor from "./ModalOutliersDesviacionProveedor";
import { DatosSesion } from "../../Components/Common/DatosSesion";

// Formatear números grandes
const formatearNumeroGrande = (numero) => {
  if (numero === null || numero === undefined) return 0;
  
  // Si el número es menor a 1000, lo devolvemos tal cual
  if (numero < 1000) {
    return numero;
  }
  // Si el número es entre 1,000 y 999,999, lo formateamos en K (miles)
  else if (numero < 1000000) {
    return (numero / 1000).toFixed(1) + "K";
  }
  // Si el número es entre 1,000,000 y 999,999,999, lo formateamos en M (millones)
  else if (numero < 1000000000) {
    return (numero / 1000000).toFixed(1) + "M";
  }
  // Si el número es mayor a 1,000,000,000, lo formateamos en B (billones)
  else {
    return (numero / 1000000000).toFixed(1) + "B";
  }
};


const Widgets = ({ fechaInicio, fechaFin, proveedorSeleccionado, aseguradora }) => {
  const [modalAyuda, setModalAyuda] = useState(false);
  const [metricaSeleccionada, setMetricaSeleccionada] = useState(null);
  const [modalOutliers, setModalOutliers] = useState(false);
  const [modalOutliersDesviacion, setModalOutliersDesviacion] = useState(false);
  const [widgetSeleccionado, setWidgetSeleccionado] = useState(null);

  // Solo los usuarios de tipo farmacia (no administradores) deben ver los modales de outliers aquí
  const perfil = DatosSesion("perfil") || "";
  const esAdministrador = perfil === "Administrador";

  const abrirAyuda = (metrica) => {
    setMetricaSeleccionada(metrica);
    setModalAyuda(true);
  };

  const abrirModalOutliers = (widget) => {
    if (esAdministrador) return; // Administradores ven outliers en Comparativa por Proveedor
    setWidgetSeleccionado(widget);
    setModalOutliers(true);
  };

  const cerrarModalOutliers = () => {
    setModalOutliers(false);
    setWidgetSeleccionado(null);
  };

  const abrirModalOutliersDesviacion = (widget) => {
    if (esAdministrador) return; // Administradores ven outliers en Comparativa por Proveedor
    setWidgetSeleccionado(widget);
    setModalOutliersDesviacion(true);
  };

  const cerrarModalOutliersDesviacion = () => {
    setModalOutliersDesviacion(false);
    setWidgetSeleccionado(null);
  };

  const selectLayoutState = (state) => state;

  const pageData = createSelector(selectLayoutState, (state) => ({
    kpis: state.Dashboard.kpis,
    loading: state.Dashboard.loading,
    errorMsg: state.Dashboard.errorMsg,
    error: state.Dashboard.error,
    colorMsg: state.Dashboard.colorMsg,
    exito: state.Dashboard.exito,
  }));

  // Inside your component
  const { kpis, loading, errorMsg, error, colorMsg, exito } =
    useSelector(pageData);

 
  // Configuración de los widgets basados en los KPIs
  const widgetsConfig = [
    {
      id: 1,
      key: "total_cotizaciones",
      label: "Total Registrado (USD)",
      badgeClass: (kpis?.total_cotizaciones?.tendencia === "up") ? "success" : 
                  (kpis?.total_cotizaciones?.tendencia === "down") ? "danger" : "muted",
      badge: (kpis?.total_cotizaciones?.tendencia === "up") ? "ri-arrow-right-up-line" : 
             (kpis?.total_cotizaciones?.tendencia === "down") ? "ri-arrow-right-down-line" : "",
      percentage: kpis?.total_cotizaciones?.porcentaje_cambio || 0,
      counter: kpis?.total_cotizaciones?.monto_usd || 0,
      formattedCounter: formatearNumeroGrande(kpis?.total_cotizaciones?.monto_usd),
      useFormatted: kpis?.total_cotizaciones?.monto_usd >= 100000,
      bgcolor: "success",
      icon: "bx bx-dollar-circle",
      decimals: 2,
      prefix: "$",
      suffix: ""
    },
    {
      id: 2,
      key: "facturas_registradas",
      label: "Facturas Registradas",
      badgeClass: (kpis?.facturas_registradas?.tendencia === "up") ? "success" : 
                  (kpis?.facturas_registradas?.tendencia === "down") ? "danger" : "muted",
      badge: (kpis?.facturas_registradas?.tendencia === "up") ? "ri-arrow-right-up-line" : 
             (kpis?.facturas_registradas?.tendencia === "down") ? "ri-arrow-right-down-line" : "",
      percentage: kpis?.facturas_registradas?.porcentaje_cambio || 0,
      counter: kpis?.facturas_registradas?.valor || 0,
      formattedCounter: formatearNumeroGrande(kpis?.facturas_registradas?.valor),
      useFormatted: kpis?.facturas_registradas?.valor >= 100000,
      bgcolor: "info",
      icon: "bx bx-receipt",
      decimals: 0,
      prefix: "",
      suffix: "",
      promedioUSD: kpis?.facturas_registradas?.promedio_usd || 0
    },
    {
      id: 3,
      key: "facturas_agudas",
      label: "Facturas Agudas",
      badgeClass: (kpis?.facturas_registradas?.desglose?.agudas?.tendencia === "up") ? "success" : 
                  (kpis?.facturas_registradas?.desglose?.agudas?.tendencia === "down") ? "danger" : "muted",
      badge: (kpis?.facturas_registradas?.desglose?.agudas?.tendencia === "up") ? "ri-arrow-right-up-line" : 
             (kpis?.facturas_registradas?.desglose?.agudas?.tendencia === "down") ? "ri-arrow-right-down-line" : "",
      percentage: kpis?.facturas_registradas?.desglose?.agudas?.porcentaje_cambio || 0,
      counter: kpis?.facturas_registradas?.desglose?.agudas?.cantidad || 0,
      formattedCounter: formatearNumeroGrande(kpis?.facturas_registradas?.desglose?.agudas?.cantidad),
      useFormatted: false,
      bgcolor: "danger",
      icon: "bx bx-file",
      decimals: 0,
      prefix: "",
      suffix: "",
      montoUSD: kpis?.facturas_registradas?.desglose?.agudas?.monto_usd || 0,
      promedioUSD: kpis?.facturas_registradas?.desglose?.agudas?.promedio_usd || 0,
      desviacionStd: kpis?.facturas_registradas?.desglose?.agudas?.desviacion_std || 0,
      outliers: kpis?.facturas_registradas?.desglose?.agudas?.outliers || null,
      outliersDesviacion: kpis?.facturas_registradas?.desglose?.agudas?.outliers_desviacion || null,
      percentiles: kpis?.facturas_registradas?.desglose?.agudas?.percentiles || null,
      coeficienteVariacion: kpis?.facturas_registradas?.desglose?.agudas?.coeficiente_variacion || null,
      alertaOutliers: kpis?.facturas_registradas?.desglose?.agudas?.alerta_outliers || null,
      alertaVariabilidad: kpis?.facturas_registradas?.desglose?.agudas?.alerta_variabilidad || null
    },
    {
      id: 4,
      key: "facturas_cronicas",
      label: "Facturas Crónicas",
      badgeClass: (kpis?.facturas_registradas?.desglose?.cronicas?.tendencia === "up") ? "success" : 
                  (kpis?.facturas_registradas?.desglose?.cronicas?.tendencia === "down") ? "danger" : "muted",
      badge: (kpis?.facturas_registradas?.desglose?.cronicas?.tendencia === "up") ? "ri-arrow-right-up-line" : 
             (kpis?.facturas_registradas?.desglose?.cronicas?.tendencia === "down") ? "ri-arrow-right-down-line" : "",
      percentage: kpis?.facturas_registradas?.desglose?.cronicas?.porcentaje_cambio || 0,
      counter: kpis?.facturas_registradas?.desglose?.cronicas?.cantidad || 0,
      formattedCounter: formatearNumeroGrande(kpis?.facturas_registradas?.desglose?.cronicas?.cantidad),
      useFormatted: false,
      bgcolor: "warning",
      icon: "bx bx-file",
      decimals: 0,
      prefix: "",
      suffix: "",
      montoUSD: kpis?.facturas_registradas?.desglose?.cronicas?.monto_usd || 0,
      promedioUSD: kpis?.facturas_registradas?.desglose?.cronicas?.promedio_usd || 0,
      desviacionStd: kpis?.facturas_registradas?.desglose?.cronicas?.desviacion_std || 0,
      outliers: kpis?.facturas_registradas?.desglose?.cronicas?.outliers || null,
      outliersDesviacion: kpis?.facturas_registradas?.desglose?.cronicas?.outliers_desviacion || null,
      percentiles: kpis?.facturas_registradas?.desglose?.cronicas?.percentiles || null,
      coeficienteVariacion: kpis?.facturas_registradas?.desglose?.cronicas?.coeficiente_variacion || null,
      alertaOutliers: kpis?.facturas_registradas?.desglose?.cronicas?.alerta_outliers || null,
      alertaVariabilidad: kpis?.facturas_registradas?.desglose?.cronicas?.alerta_variabilidad || null
    },
    {
      id: 5,
      key: "pareto",
      label: "80/20",
      badgeClass: (kpis?.pareto?.tendencia === "up") ? "success" : 
                  (kpis?.pareto?.tendencia === "down") ? "danger" : "muted",
      badge: (kpis?.pareto?.tendencia === "up") ? "ri-arrow-right-up-line" : 
             (kpis?.pareto?.tendencia === "down") ? "ri-arrow-right-down-line" : "",
      percentage: kpis?.pareto?.porcentaje_cambio || 0,
      counter: kpis?.pareto?.valor || 0,
      formattedCounter: formatearNumeroGrande(kpis?.pareto?.valor),
      useFormatted: kpis?.pareto?.valor >= 100000,
      bgcolor: "secondary",
      icon: "bx bx-pie-chart-alt-2",
      decimals: 2,
      prefix: "",
      suffix: "%",
      alerta: kpis?.pareto?.alerta
    },
    {
      id: 6,
      key: "delivery",
      label: "Delivery",
      badgeClass: (kpis?.delivery?.tendencia === "up") ? "success" : 
                  (kpis?.delivery?.tendencia === "down") ? "danger" : "muted",
      badge: (kpis?.delivery?.tendencia === "up") ? "ri-arrow-right-up-line" : 
             (kpis?.delivery?.tendencia === "down") ? "ri-arrow-right-down-line" : "",
      percentage: kpis?.delivery?.porcentaje_cambio || 0,
      counter: kpis?.delivery?.valor || 0,
      formattedCounter: `${kpis?.delivery?.valor || 0}%`,
      useFormatted: true,
      bgcolor: "danger",
      icon: "bx bx-cycling",
      decimals: 2,
      prefix: "",
      suffix: "",
      subtitle: kpis?.delivery ? `${kpis.delivery.solicitudes_entregadas || 0} de ${kpis.delivery.total_solicitudes || 0} entregadas` : "",
      alerta: kpis?.delivery?.alerta
    },
    {
      id: 7,
      key: "calificacion",
      label: "Calificación",
      badgeClass: (kpis?.calificacion?.tendencia === "up") ? "success" : 
                  (kpis?.calificacion?.tendencia === "down") ? "danger" : "muted",
      badge: (kpis?.calificacion?.tendencia === "up") ? "ri-arrow-right-up-line" : 
             (kpis?.calificacion?.tendencia === "down") ? "ri-arrow-right-down-line" : "",
      percentage: kpis?.calificacion?.porcentaje_cambio || 0,
      counter: kpis?.calificacion?.valor || 0,
      formattedCounter: `${kpis?.calificacion?.valor || 0} ⭐`,
      useFormatted: true,
      bgcolor: "primary",
      icon: "bx bx-star",
      decimals: 1,
      prefix: "",
      suffix: "",
      subtitle: kpis?.calificacion ? `${kpis.calificacion.porcentaje_satisfaccion || 0}% satisfacción (${kpis.calificacion.total_calificadas || 0} de ${kpis.calificacion.total_solicitudes || 0} calificadas)` : "",
      subtitleTooltip: "Incluye todas las calificaciones. Solicitudes crónicas pueden tener múltiples calificaciones (una por entrega).",
      alerta: kpis?.calificacion?.alerta
    }
  ];

  // Función para renderizar un widget individual
  const renderWidget = (item, key) => {
    return (
      <Card className="card-animate" style={{position: 'relative', minHeight: '160px', display: 'flex', flexDirection: 'column'}}>
        <CardBody style={{flex: 1, display: 'flex', flexDirection: 'column', padding: '1rem'}}>
              {loading && (
                <div 
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.85)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10,
                    borderRadius: '0.25rem'
                  }}
                >
                  <div className="spinner-border text-primary spinner-border-sm" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </div>
                  <small className="text-muted mt-2">Actualizando...</small>
                </div>
              )}
              <div className="d-flex align-items-center mb-2">
                <div className="flex-grow-1 overflow-hidden">
                  <div className="d-flex align-items-center gap-2">
                    <p className="text-uppercase fw-medium text-muted text-truncate mb-0" style={{fontSize: '0.75rem'}}>
                      {item.label}
                    </p>
                    {item.alerta && <AlertaBadge alerta={item.alerta} showIcon={true} />}
                  </div>
                </div>
                <div className="flex-shrink-0 d-flex align-items-center gap-2">
                  <Button
                    color="light"
                    size="sm"
                    className="btn-icon"
                    onClick={() => abrirAyuda(item.key)}
                    title="Ayuda sobre esta métrica"
                    style={{ padding: '0.15rem 0.4rem' }}
                  >
                    <i className="ri-question-line" style={{ fontSize: '12px' }}></i>
                  </Button>
                  <h5 className={"fs-14 mb-0 text-" + item.badgeClass}>
                    {item.badge ? (
                      <i className={"fs-13 align-middle " + item.badge}></i>
                    ) : null}{" "}
                    {item.percentage} %
                  </h5>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between" style={{flex: 1}}>
                <div style={{flex: 1}}>
                  <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                    <span className="counter-value" data-target="559.25">
                      {item.useFormatted ? (
                        <span>{item.prefix}{item.formattedCounter}{item.suffix}</span>
                      ) : (
                        <CountUp
                          start={0}
                          prefix={item.prefix}
                          suffix={item.suffix}
                          separator="."
                          decimal=","
                          end={item.counter}
                          decimals={item.decimals}
                          duration={4}
                        />
                      )}
                    </span>
                  </h4>
                  {item.montoUSD !== undefined && item.promedioUSD !== undefined && item.desviacionStd !== undefined && (
                    <div className="mt-2">
                      <div className="mb-1">
                        <small className="text-muted d-block mb-1" style={{fontSize: '0.7rem'}}>Total USD</small>
                        <span className="fs-13 fw-medium text-dark">
                          $ {item.montoUSD.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                        </span>
                      </div>
                      <div className="mb-1 mt-2 pt-1" style={{borderTop: '1px solid #e9ebec'}}>
                        <small className="text-muted d-block mb-1" style={{fontSize: '0.7rem'}}>Promedio USD</small>
                        <span className="fs-12 text-secondary">
                          $ {item.promedioUSD.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                        </span>
                      </div>
                      <div className="mb-1">
                        <small className="text-muted d-block mb-1" style={{fontSize: '0.7rem'}}>Desviación Estándar</small>
                        <span className="fs-12 text-info">
                          ± $ {item.desviacionStd.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                        </span>
                      </div>
                      
                      {/* Percentiles y Coeficiente de Variación */}
                      {(item.percentiles || item.coeficienteVariacion !== null) && (
                        <div className="mb-1 mt-1 pt-1" style={{borderTop: '1px solid #e9ebec'}}>
                          <small className="text-muted d-block mb-1" style={{fontSize: '0.7rem'}}>Análisis Estadístico</small>
                          <div className="d-flex gap-2 flex-wrap">
                            {item.percentiles && (
                              <PercentilesBadge 
                                percentiles={item.percentiles} 
                                label={`Percentiles - ${item.label}`}
                              />
                            )}
                            {item.coeficienteVariacion !== null && (
                              <CoeficienteVariacionBadge 
                                cv={item.coeficienteVariacion}
                                alerta={item.alertaVariabilidad}
                              />
                            )}
                          </div>
                        </div>
                      )}
                      
                      {/* Outliers IQR */}
                      {item.outliers && item.outliers.cantidad_outliers > 0 && (
                        <div 
                          className="mb-2 mt-2 pt-2" 
                          style={{
                            borderTop: '1px dashed #f06548',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            borderRadius: '4px',
                            padding: '8px'
                          }}
                          onClick={() => abrirModalOutliers(item)}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fee2e2'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                          title="Click para ver detalles de outliers IQR"
                        >
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <small className="text-muted" style={{fontSize: '0.7rem'}}>
                              <i className="ri-alert-line text-danger"></i> Valores Extremos (IQR)
                            </small>
                            {item.alertaOutliers && (
                              <AlertaBadge alerta={item.alertaOutliers} size="sm" showIcon={false} showText={false} />
                            )}
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="fs-11 text-danger fw-medium">
                              <i className="ri-alert-fill me-1"></i>
                              {item.outliers.cantidad_outliers} outlier{item.outliers.cantidad_outliers > 1 ? 's' : ''}
                            </span>
                            <span className="badge bg-danger" style={{fontSize: '0.65rem'}}>
                              {item.outliers.porcentaje_outliers}%
                            </span>
                          </div>
                          <div className="mt-1">
                            <small className="text-muted d-block" style={{fontSize: '0.65rem'}}>
                              Rango: ${item.outliers.limite_inferior.toFixed(2)} - ${item.outliers.limite_superior.toFixed(2)}
                            </small>
                          </div>
                        </div>
                      )}

                      {/* Outliers Desviación Estándar */}
                      {item.outliersDesviacion && item.outliersDesviacion.cantidad_outliers > 0 && (
                        <div 
                          className="mb-2 mt-2 pt-2" 
                          style={{
                            borderTop: '1px dashed #405189',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            borderRadius: '4px',
                            padding: '8px'
                          }}
                          onClick={() => abrirModalOutliersDesviacion(item)}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                          title="Click para ver detalles de outliers por desviación estándar"
                        >
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <small className="text-muted" style={{fontSize: '0.7rem'}}>
                              <i className="ri-line-chart-line text-primary"></i> Desviación Estándar (σ)
                            </small>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="fs-11 text-primary fw-medium">
                              <i className="ri-line-chart-line me-1"></i>
                              {item.outliersDesviacion.cantidad_outliers} outlier{item.outliersDesviacion.cantidad_outliers > 1 ? 's' : ''}
                            </span>
                            <span className="badge bg-primary" style={{fontSize: '0.65rem'}}>
                              {item.outliersDesviacion.porcentaje_outliers}%
                            </span>
                          </div>
                          <div className="mt-1">
                            <small className="text-muted d-block" style={{fontSize: '0.65rem'}}>
                              Rango: ${item.outliersDesviacion.limite_inferior?.toFixed(2) || '0.00'} - ${item.outliersDesviacion.limite_superior?.toFixed(2) || '0.00'}
                            </small>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {item.promedioUSD !== undefined && item.montoUSD === undefined && item.desviacionStd === undefined && (
                    <div className="mt-1">
                      <small className="text-muted d-block" style={{fontSize: '0.7rem'}}>Promedio por factura</small>
                      <div className="mt-1">
                        <small className="text-secondary fs-12">
                          $ {item.promedioUSD.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                        </small>
                      </div>
                    </div>
                  )}
                  {item.subtitle && (
                    <div className="mt-1">
                      <small className="text-muted" style={{fontSize: '0.7rem'}}>
                        {item.subtitle}
                        {item.subtitleTooltip && (
                          <i 
                            className="ri-information-line ms-1" 
                            style={{fontSize: '0.8rem', cursor: 'help'}}
                            title={item.subtitleTooltip}
                          ></i>
                        )}
                      </small>
                    </div>
                  )}
                </div>
                <div className="avatar-sm flex-shrink-0 ms-3">
                  <span
                    className={
                      "avatar-title rounded fs-3 bg-" + item.bgcolor + "-subtle"
                    }
                  >
                    <i className={`text-${item.bgcolor} ${item.icon}`}></i>
                  </span>
                </div>
              </div>
        </CardBody>
      </Card>
    );
  };

  return (
    <>
      <DraggableKPIs 
        widgetsConfig={widgetsConfig} 
        renderWidget={renderWidget}
        fechaInicio={fechaInicio}
        fechaFin={fechaFin}
        proveedorSeleccionado={proveedorSeleccionado}
      />
      
      {/* Modal de Ayuda */}
      <ModalAyudaMetrica 
        isOpen={modalAyuda}
        toggle={() => setModalAyuda(!modalAyuda)}
        metrica={metricaSeleccionada}
      />

      {/* Modal de Outliers (IQR) */}
      {widgetSeleccionado && (
        <ModalOutliersProveedor
          isOpen={modalOutliers}
          toggle={cerrarModalOutliers}
          proveedor={{
            codigo: proveedorSeleccionado || DatosSesion("farmacia") || DatosSesion("id") || 'GLOBAL',
            nombre: widgetSeleccionado.label,
            total_facturas: widgetSeleccionado.counter,
            promedio_usd: widgetSeleccionado.promedioUSD || 0,
            outliers_facturas: {
              total: widgetSeleccionado.outliers?.cantidad_outliers || 0,
              porcentaje: widgetSeleccionado.outliers?.porcentaje_outliers || 0,
              agudas: widgetSeleccionado.key === 'facturas_agudas' ? widgetSeleccionado.outliers : { cantidad_outliers: 0, porcentaje_outliers: 0 },
              cronicas: widgetSeleccionado.key === 'facturas_cronicas' ? widgetSeleccionado.outliers : { cantidad_outliers: 0, porcentaje_outliers: 0 }
            }
          }}
          fechaInicio={fechaInicio}
          fechaFin={fechaFin}
          aseguradora={aseguradora}
        />
      )}

      {/* Modal de Outliers (Desviación Estándar) */}
      {widgetSeleccionado && (
        <ModalOutliersDesviacionProveedor
          isOpen={modalOutliersDesviacion}
          toggle={cerrarModalOutliersDesviacion}
          proveedor={{
            codigo: proveedorSeleccionado || DatosSesion("farmacia") || DatosSesion("id") || 'GLOBAL',
            nombre: widgetSeleccionado.label
          }}
          fechaInicio={fechaInicio}
          fechaFin={fechaFin}
          aseguradora={aseguradora}
        />
      )}
    </>
  );
};

export default Widgets;
